import { Component, OnInit } from '@angular/core';
import { BookNoSearch } from '../../models/bookno-receipt-model';
import { Txncategory } from '../../models/tallyentry-api-model';
import { PurposeLedgerMapHeader } from '../../models/purpose-leger-mapmaster-mode';
import { CategoryPurposeModel } from '../../models/tallyentry-model';
import { UtilityService } from '../../services/utility-service';
import { TallyReceiptService } from '../../services/tallyentry-service';
import { LedgerHead } from '../../models/mapping-transaction-model';
import { MappingTransactionsService } from '../../services/mapping-transactions-service';
import { MatTableDataSource } from '@angular/material/table';
import { DayBookList } from '../../models/daybook-model';
import { AccountsMastersService } from '../../services/accounts-masters-service';

@Component({
  selector: 'app-purpose-ledger-mapmaster',
  templateUrl: './purpose-ledger-mapmaster.component.html',
  styleUrls: ['./purpose-ledger-mapmaster.component.css']
})
export class PurposeLedgerMapmasterComponent implements OnInit {

  public l_categorySelect: Txncategory[] = [];
  public l_categoryPurposeSelect: CategoryPurposeModel[] = [];
  public l_purposeLedgerMapHdr: PurposeLedgerMapHeader = new PurposeLedgerMapHeader();
  public modeOfPaymentEnum: any[] = [];
  public l_purposeSelect: CategoryPurposeModel[] = [];
  public l_ledgerHeadList: LedgerHead[] = [];
  public l_selectedLedgerHeadVals: number[] = [];

  public dataSource = new MatTableDataSource<PurposeLedgerMapHeader>();
  public displayedColumns: string[] = ['txncategory', 'purpose', 'modeOfPayment', 'approvalStatus', 'actions'];

  constructor(
    private l_UtilityService: UtilityService,
    private l_TallyReceiptService: TallyReceiptService,
    private l_MappingTransactionsService: MappingTransactionsService,
    private l_AccountsMasterService: AccountsMastersService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.lFN_GetCategorySelect();
    await this.lFN_GetCategoryPurposeList();
    await this.lFN_GetLedgerHeadAccounts();
    await this.lFN_GetPurposeLedgerheadMapping();
  }

  async lFN_GetCategorySelect() {
    let l_response = this.l_TallyReceiptService.lFN_GetCategory();
    l_response.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_categoryResponseList: Txncategory[] = [];
          for await (const l_category of JSON.parse(data.body)) {
            l_categoryResponseList.push(new Txncategory(l_category));
          }
          this.l_categorySelect = l_categoryResponseList;
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch category list.', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        //this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_GetCategoryPurposeList() {
    let l_response = this.l_TallyReceiptService.lFN_GetCategoryPurpose();
    l_response.subscribe(async (data)=> {
      if(data.status == 200) {
        let l_categoryPurposeSelect: CategoryPurposeModel[] = [];
        for await (const iterator of JSON.parse(data.body)) {
          l_categoryPurposeSelect.push(iterator);
        }
        this.l_categoryPurposeSelect = l_categoryPurposeSelect;
      } else {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch category purpose list.', 'Failure');
      }
    });
  }

  async lFN_GetPurposeSelect(l_txncategoryId) {
    let l_txnIdSelected = ((l_txncategoryId.value) ? l_txncategoryId.value : l_txncategoryId);
    let l_PurposeList = this.l_categoryPurposeSelect.filter((l_category) => l_category.txncategoryId === l_txnIdSelected);
    this.l_purposeSelect = l_PurposeList;
  }

  async lFN_GenerateModePaymentList() {
    this.l_purposeLedgerMapHdr.modeOfPayment = "";
    let l_categoryIdSelected = this.l_purposeLedgerMapHdr.txncategory.txncategoryId;
    let l_purposeIdSelected = this.l_purposeLedgerMapHdr.purpose.purposeId;
    let l_categoryName = this.l_categorySelect.find(l_category => (l_category.txncategoryId === l_categoryIdSelected)).name;
    let l_purposeName = this.l_categoryPurposeSelect.find(l_purpose=> (l_purpose.purposeId === l_purposeIdSelected)).purpose;
    //console.log('l_categoryName == ', l_categoryName);
    //console.log('l_purposeName == ', l_purposeName);
    this.modeOfPaymentEnum = await this.l_UtilityService.lFN_GetModePaymentList(l_categoryName, l_purposeName);
  }

  async lFN_GetLedgerHeadAccounts() {
    let l_ledgerHeadResponse = this.l_MappingTransactionsService.lFN_GetLedgerHeads();
    l_ledgerHeadResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          for await (const l_ledgerhead of JSON.parse(data.body)) {
            let l_ledger = new LedgerHead(l_ledgerhead);
            this.l_ledgerHeadList.push(l_ledger);
          }
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch ledger heads', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_SaveMasterMapping() {
    console.log('l_selectedLedgerHeadVals === ', this.l_selectedLedgerHeadVals);
    
    let l_ledgerHeadSelectedList: LedgerHead[] = [];
    for await (const element of this.l_selectedLedgerHeadVals) {
      let l_ledgerObject = this.l_ledgerHeadList.find(l_ledger => l_ledger.ledgerHeadId === element);
      l_ledgerHeadSelectedList.push(l_ledgerObject);
    }
    console.log('l_ledgerHeadSelectedList === ', l_ledgerHeadSelectedList);

    this.l_purposeLedgerMapHdr.ledgerHeadList = l_ledgerHeadSelectedList;
    this.l_purposeLedgerMapHdr.approvalStatus = ((this.l_purposeLedgerMapHdr.approvalStatus) ? this.l_purposeLedgerMapHdr.approvalStatus: false);
    console.log('l_purposeLedgerMapHdr === ', this.l_purposeLedgerMapHdr);

    // let l_purposeLedgerMapResponse = this.l_AccountsMasterService.lFN_SavePurposeMappingMasterTransactions(this.l_purposeLedgerMapHdr);
    // l_purposeLedgerMapResponse.subscribe({
    //   next: async (data) => {
    //     if (data.status == 200) {
    //       this.l_UtilityService.lFN_SuccessToaster('Accounts Purpose Ledger Master Mapping saved successfully', 'Save Successfully');
    //       await this.lFN_GetPurposeLedgerheadMapping();
    //       this.l_UtilityService.lFN_HideLoader();
    //     }
    //   },
    //   error: (l_error) => {
    //     this.l_UtilityService.lFN_ErrorToaster('Unable to save purpose ledgerhead mapping master entry', 'Failure');
    //     this.l_UtilityService.lFN_HideLoader();
    //   },
    //   complete: () => {
    //     this.l_UtilityService.lFN_HideLoader();
    //   }
    // });
  }

  async lFN_EditLedgerMapping(l_event: any) {
    console.log('lFN_EditLedgerMapping l_event === ', l_event);
    let l_purposeLedgerMapHdrObject = new PurposeLedgerMapHeader(l_event);
    this.l_purposeLedgerMapHdr.txncategory.txncategoryId = l_purposeLedgerMapHdrObject.txncategory.txncategoryId;
    
    await this.lFN_GetPurposeSelect(l_purposeLedgerMapHdrObject.txncategory.txncategoryId);
    this.l_purposeLedgerMapHdr.purpose.purposeId = l_purposeLedgerMapHdrObject.purpose.purposeId;

    await this.lFN_GenerateModePaymentList();
    this.l_purposeLedgerMapHdr.modeOfPayment = l_purposeLedgerMapHdrObject.modeOfPayment;

    let l_ledgerHeadListPopulate: number[] = [];
    for await (const l_ledgerHead of l_purposeLedgerMapHdrObject.ledgerHeadList) {
      l_ledgerHeadListPopulate.push(l_ledgerHead.ledgerHeadId);
    }
    this.l_selectedLedgerHeadVals = l_ledgerHeadListPopulate;
  }

  async lFN_ApproveMapping(l_event: any) {
    console.log('lFN_ApproveMapping l_event === ', l_event);
    let l_approvalMasterResponse = this.l_AccountsMasterService.lFN_ApprovePurposeMappingMaster(l_event);
    l_approvalMasterResponse.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          this.l_UtilityService.lFN_SuccessToaster('Accounts Purpose Ledger Master Mapping approved successfully', 'Approved Successfully');
          await this.lFN_GetPurposeLedgerheadMapping();
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to approve purpose ledgerhead mapping list', 'Something went wrong');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }

  async lFN_ViewMapping(l_event: any) {
    console.log('lFN_ViewMapping l_event === ', l_event);
  }

  async lFN_GetPurposeLedgerheadMapping() {
    let l_purposeLedgerMapList = this.l_AccountsMasterService.lFN_GetPurposeLedgerHeadsMappingList();
    l_purposeLedgerMapList.subscribe({
      next: async (data) => {
        if (data.status == 200) {
          let l_filteredList: PurposeLedgerMapHeader[] = [];
          for await (const l_purposeledgerheadmap of JSON.parse(data.body)) {
            let l_mapobject = new PurposeLedgerMapHeader(l_purposeledgerheadmap);
            l_filteredList.push(l_mapobject);
          }
          //console.log('l_filteredList === ', l_filteredList);
          l_filteredList.sort();
          this.dataSource.data = l_filteredList;
          this.l_UtilityService.lFN_HideLoader();
        }
      },
      error: (l_error) => {
        this.l_UtilityService.lFN_ErrorToaster('Unable to fetch purpose ledgerhead mapping list', 'Failure');
        this.l_UtilityService.lFN_HideLoader();
      },
      complete: () => {
        this.l_UtilityService.lFN_HideLoader();
      }
    });
  }


}
